import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ImagesService } from '../../../shared/services/images.service';
import { AttachmentTypes, IAttachment } from '../../interfaces/IAttachment';

@Component({
  selector: 'media-upload-msg',
  templateUrl: './media-upload.component.html',
  styleUrls: ['./media-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MediaComponent implements OnInit {
  @Input() attachment: IAttachment;
  errorOnLoad: boolean;

  constructor(public imagesService: ImagesService) {}

  ngOnInit(): void {
    this.setTypes();
  }

  setTypes(): void {
    if (!this.attachment) return;
    const { thumbnailURL, title } = this.attachment;
    if (this.hasValidExtension(thumbnailURL as string) || this.hasValidExtension(title ?? '')) {
      this.attachment = { ...this.attachment, type: AttachmentTypes.DOCUMENT };
    }
  }

  onImageError() {
    this.errorOnLoad = true;
  }

  hasValidExtension(url: string): boolean {
    if (!url) return false;
    const validExtensions = ['.amr', '.mpeg'];
    return validExtensions.some((extension) => url.includes(extension));
  }

  get AttachmentTypes(): typeof AttachmentTypes {
    return AttachmentTypes;
  }
}
